<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input
        class="form-control"
        type="text"
        v-model="block.header"
        :placeholder="$t('Header')"
        maxlength="200"
      />
    </div>
    <hr />
    <div class="mb-3">
      <label for="">{{ 'Date' | translate }}</label>
      <input
        key="date"
        class="form-control"
        type="text"
        placeholder="YYYY-MM-DD"
        v-model="date"
        v-mask="'####-##-##'"
        @change="updateBlock"
      />
    </div>
    <div class="mb-3">
      <label for="">{{ 'Time' | translate }}</label>
      <input
        key="time"
        class="form-control"
        type="text"
        placeholder="HH:mm"
        v-model="time"
        @change="updateBlock"
        v-mask="'##:##'"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mask } from 'vue-the-mask'
import dayjs from 'dayjs'

export default {
  directives: {
    mask,
  },
  props: ['block'],
  data() {
    return {
      end_date: _.get(this.block, 'settings.end_date') || '',
      time: this.getTime(),
      date: this.getDate(),
    }
  },
  methods: {
    change() {
      let previousSettings = _.get(this.block, 'settings')
      let newSettings = { end_date: this.end_date }

      if (previousSettings) {
        newSettings = {
          ...previousSettings,
          ...newSettings,
        }
      }
      newSettings = _(newSettings)
        .omitBy(_.isNil)
        .omitBy((value) => {
          return _.isEmpty(value) && !_.isInteger(value) && !_.isBoolean(value)
        })
        .value()

      if (_.isEmpty(newSettings)) {
        newSettings = null
      }

      this.block.settings = newSettings
    },
    getTime() {
      let date = new Date()
      if (Date.parse(this.block.settings.end_date)) {
        date = new Date(this.block.settings.end_date)
      }
      return `${date.getHours()}:${date.getMinutes()}`
    },
    getDate() {
      let date = new Date()
      if (Date.parse(this.block.settings.end_date)) {
        date = new Date(this.block.settings.end_date)
      }
      return date.toISOString().substr(0, 10)
    },
    updateBlock(e) {
      let d = dayjs(`${this.date} ${this.time}`)
      if (d) {
        this.end_date = d.toISOString()
      } else {
        this.end_date = dayjs().toISOString()
      }
      this.change()
    },
  },
}
</script>
